export const slackNotificationWebsocket = {
    baseURL: "https://slacksocket.insights.sailgp.tech"
};

export const broadcasterConfig = {
    baseUrl: "https://broadcasterconfig.sailgp.com"
}
